export default __webpack_public_path__ + "static/media/label.53de9638.png";